import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Typography,
  Row,
  Col,
  Input,
  message,
} from "antd";
import { platformApi } from "../../../../../api";

const { Item } = Form;
const { Text } = Typography;
const { Option } = Select;

const VehicleData = ({
  form,
  data,
  recvData,
  editable,
  validate,
  setValidate,
}) => {
  const { getFieldDecorator, getFieldValue } = form;
  const [templates, setTemplates] = useState([]);
  const [selectedContent, setSelectedContent] = useState("");

  const parseStoredTemplateName = (sms) => {
    if (!sms) return undefined;
    try {
      const parsed = JSON.parse(sms);
      if (Array.isArray(parsed)) return parsed[0] || undefined;
      if (typeof parsed === "string") return parsed;
    } catch (e) {
      return typeof sms === "string" ? sms : undefined;
    }
    return undefined;
  };

  const resolveContent = (templateName, list = templates) => {
    if (!templateName) return "";
    const match = (list || []).find((t) => t.name === templateName);
    return (match && match.text) || "";
  };

  useEffect(() => {
    validate.add(validatePage);
    setValidate(validate);

    platformApi
      .get("/api/whatsapp/promoWhatsapp?status=APPROVED")
      .then((res) => {
        if (res.data.code === 200) {
          const list = (res.data.msg && res.data.msg.data) || [];
          const approved = (list || []).filter((t) => t && t.name);
          setTemplates(approved);

          const existingName = Array.isArray(data.templates)
            ? data.templates[0]
            : Array.isArray(data.text)
            ? data.text[0]
            : data.text;
          if (existingName) {
            form.setFieldsValue({ text: existingName });
            setSelectedContent(resolveContent(existingName, approved));
          }
        } else {
          message.error("Unable to fetch approved WhatsApp templates", 2);
        }
      })
      .catch(() => {
        message.error("Unable to fetch approved WhatsApp templates", 2);
      });

    const initialName = Array.isArray(data.templates)
      ? data.templates[0]
      : Array.isArray(data.text)
      ? data.text[0]
      : data.text;
    form.setFieldsValue({
      name: data.name,
      text: initialName || undefined,
    });
  }, []);

  useEffect(() => {
    if (recvData) {
      const storedName = parseStoredTemplateName(
        recvData.message && recvData.message.sms
      );
      form.setFieldsValue({
        name: recvData.message ? recvData.message.promotionName : undefined,
        text: storedName,
      });
      setSelectedContent(resolveContent(storedName));
      data.id = recvData.id;
      if (storedName) {
        data.templates = [storedName];
        data.text = [storedName];
      }
    }
  }, [recvData, editable, templates]);

  const validatePage = () => {
    let isValid;
    form.validateFields((validationError) => {
      isValid = validationError === null;
    });
    if (isValid) {
      data.name = getFieldValue("name");
      const selected = getFieldValue("text");
      data.templates = selected ? [selected] : [];
      data.text = data.templates;
    }
    return isValid;
  };

  return (
    <Form style={{ marginTop: 0 }}>
      <Row type="flex" justify="space-between">
        <Col span={7}>
          <Item
            label={<Text>Promotion Name</Text>}
            colon={false}
            style={{ marginBottom: 12 }}
          >
            {getFieldDecorator("name")(
              <Input
                disabled={!editable}
                placeholder="Promotion Name"
                onKeyUp={(e) => {
                  const value = e.target.value.replace(
                    /[^a-zA-Z0-9\s\-.,/]/g,
                    ""
                  );
                  form.setFieldsValue({
                    name: value,
                  });
                }}
                onInput={(event) => {
                  const rawValue = event.target.value;
                  const filteredValue = rawValue.replace(
                    /[^a-zA-Z0-9\s\-.,/]/g,
                    ""
                  );
                  if (filteredValue !== rawValue) {
                    event.target.value = filteredValue;
                    form.setFieldsValue({
                      name: filteredValue,
                    });
                  }
                }}
              />
            )}
          </Item>
        </Col>
      </Row>
      <Row>
        <Col span={10}>
          <Item label="WhatsApp Template" colon={false}>
            {getFieldDecorator("text", {
              rules: [
                {
                  required: true,
                  message: "Select an approved WhatsApp template",
                },
              ],
            })(
              <Select
                disabled={!editable}
                placeholder="Select WhatsApp template"
                allowClear
                showSearch
                optionFilterProp="children"
                style={{ width: "100%" }}
                onChange={(value) => {
                  const name = value || undefined;
                  data.templates = name ? [name] : [];
                  data.text = data.templates;
                  setSelectedContent(resolveContent(name));
                }}
              >
                {templates.map((tpl) => (
                  <Option key={tpl.id || tpl.name} value={tpl.name}>
                    {tpl.name}
                  </Option>
                ))}
              </Select>
            )}
          </Item>
        </Col>
      </Row>
      <Row>
        <Col span={14}>
          <Item label="WhatsApp Template Content" colon={false}>
            <div
              style={{
                minHeight: 64,
                padding: "8px 11px",
                border: "1px solid #d9d9d9",
                borderRadius: 4,
                background: "#f5f5f5",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                color: selectedContent
                  ? "rgba(0, 0, 0, 0.65)"
                  : "rgba(0, 0, 0, 0.25)",
                lineHeight: 1.5,
              }}
            >
              {selectedContent || "Selected template message will appear here"}
            </div>
          </Item>
        </Col>
      </Row>
    </Form>
  );
};

const WrappedVehicleData = Form.create()(VehicleData);

export default WrappedVehicleData;
